export const mvaRegistrert = {
  utenMva: "utenMva",
  medMva: "medMva",
} as const
